import React from "react";
import Style from "../../styles/js/StyleNotifications.js";
import InitialState from "./images/androidNotification.png";
import ExpandedAndroid from "./images/android.png";
import DefaultImage from "./images/defaultImage.png";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import * as ScreenText from "../../consts/ScreenText.js";
import { isEmptyString } from "../../utils/StringUtils.js";

export default function CellPhone({ view, title, body, link, image }) {
  const INITIAL_VIEW = 0;

  const style = Style();

  const getTitle = () => {
    if (isEmptyString(title)) return ScreenText.NOTIFICATIONS_CELLPHONE_TITLE;
    return title;
  };

  const getBody = () => {
    if (isEmptyString(body)) return ScreenText.NOTIFICATIONS_CELLPHONE_BODY;
    return body;
  };

  const getImage = () => {
    if (image === null) return DefaultImage;
    return image.image;
  };

  return (
    <div className={style.cellPhone}>
      <img src={view === INITIAL_VIEW ? InitialState : ExpandedAndroid} />
      <Paper
        className={
          view === INITIAL_VIEW
            ? style.notificationPaper
            : style.notificationExpandedPaper
        }
      >
        <div className={style.text}>
          <Typography
            className={
              view === INITIAL_VIEW ? style.titleInitial : style.titleExpanded
            }
          >
            {getTitle()}
          </Typography>
          <Typography
            className={
              view === INITIAL_VIEW ? style.bodyInitial : style.bodyExpanded
            }
          >
            {getBody()}
          </Typography>
        </div>
        <img src={getImage()} className={style.image} />
      </Paper>
    </div>
  );
}
